
import { Component, Prop, Vue } from 'vue-property-decorator';
import Icon from '@/components/UI/Icon.vue';

@Component({
  components: {
    Icon,
  },
})
export default class Button extends Vue {
  @Prop({ type: String, required: false, default: 'normal' }) public size: string;
  @Prop({ type: String, required: false, default: 'purple' }) public color: string;
  @Prop({ type: String, required: false, default: '' }) public colorIntensity: string;
  @Prop({ type: String, required: false, default: 'Done' }) public text: string;
  @Prop({ type: String, required: false, default: 'mdi-check' }) public icon: string;
  @Prop({ type: Boolean, required: false, default: false }) public loading: boolean;
  @Prop({ type: Boolean, required: false, default: false }) public disabled: boolean;
}
